import React from "react";
import Analytics from "./Analytics/Analytics";
import _Aux from "./_Aux";

const App = () => (
  <_Aux>
    <Analytics />
  </_Aux>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js